import { useEffect, useMemo } from "react";

export const useObjectUrl = (blob: Blob | undefined) => {
  const objectUrl = useMemo(() => {
    if (!blob) return undefined;
    return URL.createObjectURL(blob);
  }, [blob]);

  useEffect(() => {
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [objectUrl]);

  return objectUrl;
};
